import { createRoot } from 'react-dom/client';
import { AppRoutes } from 'router';

const rootEl = document.getElementById('root');
const root = createRoot(rootEl);
root.render(<AppRoutes />);
